class ShopifyProductRecommendations extends window.BAO.CustomElement() {
  static get requiredAttributes () {
    return ['data-recommendations-url', 'data-product-id', 'data-section-id']
  }

  static get observedAttributes () {
    return ['data-product-id']
  }

  async attributeChangedCallback (name) {
    if (name !== 'data-product-id') return

    await this.render()
  }

  connectedCallback () {
    this.render()
  }

  async render () {
    this.innerHTML = await this.fetch()
  }

  async fetch () {
    if (!this.productId?.length) return ''

    let html = ''
    if (this.cacheCurrency === window.theme.currency) {
      html = this.cachedHTML || (await this.fetchRecommendations())
    } else {
      html = (await this.fetchRecommendations())
    }

    if (!html || !html.length) return ''

    this.updateCache({
      productId: this.productId,
      html,
    })

    return html
  }

  async fetchRecommendations () {
    try {
      const response = await fetch(`${this.recommendationsUrl}?${this.params}`)
      if (!response.ok) {
        console.error('Network response was not ok', response.statusText)
        return ''
      }
      const text = await response.text()

      if (!text || !text.length) {
        console.error('Response text is empty')
        return ''
      }

      return this.sectionRenderer.getInnerHtml(text)
    } catch (error) {
      console.error('Fetch error:', error)
      return ''
    }
  }

  updateCache ({ productId, html }) {
    const cache = this.cache || {}
    cache[productId] = html
    const cacheCurrency = window.theme.currency

    window.sessionStorage.setItem(this.storageKeyCurrency, cacheCurrency)
    window.sessionStorage.setItem(this.storageKey, JSON.stringify(cache))
  }

  get sectionRenderer () {
    return window.BAO.sectionRenderer
  }

  get cachedHTML () {
    return this.cache?.[this.productId]
  }

  get cache () {
    const cache = window.sessionStorage.getItem(this.storageKey)

    return cache ? JSON.parse(cache) : {}
  }

  get cacheCurrency () {
    const cacheCurrency = window.sessionStorage.getItem(this.storageKeyCurrency)

    return cacheCurrency
  }

  get params () {
    const params = new URLSearchParams()
    params.set('product_id', this.productId)
    params.set('section_id', this.sectionId)
    params.set('limit', this.limit)

    return params.toString()
  }

  get recommendationsUrl () {
    return this.dataset.recommendationsUrl
  }

  get productId () {
    return this.dataset.productId
  }

  get sectionId () {
    return this.dataset.sectionId
  }

  get limit () {
    return this.dataset.limit || 10
  }

  get storageKey () {
    // Updating Key Counter to ensure Cache clears on release
    return `BAO-product-recommendations-${this.sectionId}-${this.limit}-1`
  }

  get storageKeyCurrency () {
    // Updating Key Counter to ensure Cache clears on release
    return `BAO-product-recommendations-${this.sectionId}-${this.limit}-currency-1`
  }
}

if (!window.customElements.get('shopify-product-recommendations')) {
  window.customElements.define(
    'shopify-product-recommendations',
    ShopifyProductRecommendations,
  )
}
